module.exports = __webpack_public_path__ + "static/media/mini.360f6e3.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mp3/mini.mp3
// module id = HEh8
// module chunks = 1 3